module.exports = __webpack_public_path__ + "static/media/caffeine.4d5bc9a2.png";